import { PayloadAction } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { IForm } from 'core-components/classes/models/IForm'

import { mapRequestFromCrud } from '../../services/mapping/mapRequestFromCrud'
import { IOnboardingState, IParentRequestActionParams } from '../models'

export const getParentRequestPending = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IParentRequestActionParams }>
) => {
  const { meta } = action
  state.parentRequestData.meta = meta
  state.parentRequestData.status = RequestStatus.PENDING
  state.parentRequestData.message = ''
}

export const getParentRequestRejected = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IParentRequestActionParams }>
) => {
  const { meta } = action
  state.parentRequestData.meta = meta
  state.parentRequestData.status = RequestStatus.REJECTED
  state.parentRequestData.message = action.payload as string
}

export const getParentRequestFulfilled = (
  state: IOnboardingState,
  action: PayloadAction<IForm | null, string, { arg: IParentRequestActionParams }>
) => {
  const { meta, payload } = action
  state.parentRequestData.meta = meta
  state.parentRequestData.status = RequestStatus.FULFILLED
  state.parentRequestData.message = ''
  if (payload && payload.request) {
    state.parentRequestData.data = mapRequestFromCrud(payload.request)
  }
}
